module.exports = __webpack_public_path__ + "static/media/broacast8.abadfc49.png";